module.exports = __webpack_public_path__ + "static/media/M41ws.195fe7b8.pdf";